import CrossIcon from '@ui-components-3/icons/lib/duotone/HexagonXmark'
import MessagesList from './MessagesList'
import MessageTextarea from './MessageTextarea'

/* 
    TODO:
        add types after typing models
*/
type ChatProps = {
  visit: any
  onClose: () => void
}

const Chat = ({ visit, onClose }: ChatProps) =>
  visit ? (
    <div className="fixed translate-x-1/2 translate-y-1/2 bottom-1/2 right-1/2 sm:rounded-t sm:translate-y-0 sm:translate-x-0 sm:bottom-0 sm:right-xl min-h-[25em] h-[45vh] w-[30em] max-w-[86vw] flex flex-col p-xs bg-neutral-200 border z-[10]">
      <div className="flex justify-end">
        <button type="button" className="btn-tiny btn-primary-borderless" onClick={onClose}>
          <CrossIcon aria-label="Close" className="h-m" />
        </button>
      </div>
      <MessagesList visit={visit} />
      <MessageTextarea visit={visit} className="mx-s my-xs" />
    </div>
  ) : null

export default Chat
